export enum Icons {
    notification = '/img/itemviewer/notification-icon.png',
  }
  